var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 21.3836L11.6029 20.8571C16.673 16.43 19.25 12.5645 19.25 9.16663C19.25 4.35473 15.4944 0.916626 11 0.916626C6.50563 0.916626 2.75 4.35473 2.75 9.16663C2.75 12.5645 5.32703 16.43 10.3971 20.8571L11 21.3836ZM11 18.9414C6.69773 15.064 4.58333 11.7784 4.58333 9.16663C4.58333 5.40518 7.48377 2.74996 11 2.74996C14.5162 2.74996 17.4167 5.40518 17.4167 9.16663C17.4167 11.7784 15.3023 15.064 11 18.9414ZM11 4.58329C13.5313 4.58329 15.5833 6.63532 15.5833 9.16663C15.5833 11.6979 13.5313 13.75 11 13.75C8.46869 13.75 6.41667 11.6979 6.41667 9.16663C6.41667 6.63532 8.46869 4.58329 11 4.58329ZM8.25 9.16663C8.25 7.64784 9.48122 6.41663 11 6.41663C12.5188 6.41663 13.75 7.64784 13.75 9.16663C13.75 10.6854 12.5188 11.9166 11 11.9166C9.48122 11.9166 8.25 10.6854 8.25 9.16663Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.453af1d964ad6479ba57d5c26fb3dabb.svg";
export { ForwardRef as ReactComponent };